/** @format */
import React from 'react'
import styled from 'styled-components'
import { _$ } from '@king-design/react'

interface INoDataProps {
  className?: string
  text?: string
  style?: any
}

const NoDataComponent: React.FC<INoDataProps> = ({ className, text, style }) => {
  return (
    <p className={className} style={{ ...style }}>
      {text || `/(ㄒoㄒ)/~~ ${_$('没有找到亲要的数据哦')}~`}
    </p>
  )
}

export default styled(NoDataComponent)`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 50px 0;
  margin: 0;
`
